import { DictionaryObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Document } from './document.model';
import { Partner } from './partner.model';

export enum CustomizationSettingsIdentifier {
    Stay = 'stay',
    Enjoy = 'enjoy',
    Discover = 'discover'
}

export interface CustomizationSettingsElem {
    identifier: CustomizationSettingsIdentifier,
    title: DictionaryObject | string,
    picture: Document | string,
    isTitleDefault: boolean,
    isPictureDefault: boolean,
}

@CwtModel({ name: 'customizationSettings', path: '/customization-settings' })
export class CustomizationSettings extends ApiData {
    _id?: string;
    partner?: Partner;
    stayCardInfo?: CustomizationSettingsElem;
    enjoyCardInfo?: CustomizationSettingsElem;
    discoverCardInfo?: CustomizationSettingsElem;
} 
